import { Button, Tooltip } from '@mui/material'
import { memo, ReactElement } from 'react'
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined'
import { useTranslation } from 'react-i18next'

interface CertificateViewerProps {
    pdfBase64: string
}

const CertificateViewer = (
    props: CertificateViewerProps,
): ReactElement | null => {
    const { t } = useTranslation()
    const { pdfBase64 } = props
    const handleOpenPDF = () => {
        try {
            // Decode the Base64 string
            const binaryString = atob(pdfBase64)
            const binaryLen = binaryString.length
            const bytes = new Uint8Array(binaryLen)

            for (let i = 0; i < binaryLen; i++) {
                bytes[i] = binaryString.charCodeAt(i)
            }

            // Create a Blob with the binary data
            const blob = new Blob([bytes], { type: 'application/pdf' })

            // Generate a URL for the Blob
            const pdfUrl = URL.createObjectURL(blob)

            // Open the PDF in a new browser tab
            window.open(pdfUrl, '_blank')

            // Optionally revoke the URL after some time
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000) // 1 minute
        } catch (error) {
            console.error('Failed to open PDF:', error)
        }
    }

    return pdfBase64 ? (
        <Button
            id="base64-pdf-button-view"
            onClick={handleOpenPDF}
            sx={{
                fontSize: '14px',
                color: '#6d6dff',
                cursor: 'pointer',
                justifyContent: 'left',
                padding: '0px',
                minWidth: '0px',
            }}
        >
            <Tooltip title={t('viewCertificate')} placement="top" arrow>
                <SourceOutlinedIcon />
            </Tooltip>
        </Button>
    ) : null
}

const MemoizedCertificateViewer = memo(CertificateViewer)
MemoizedCertificateViewer.displayName = 'CertificateViewer'
export default MemoizedCertificateViewer
